export default __webpack_public_path__ + "static/media/typePerson.ef27839d.ef27839d.svg";